var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.intObseverCfg),expression:"intObseverCfg"}],attrs:{"background":"fill-4","slanted":1,"height":100,"pad-h":""}},[_c('div',{staticClass:"container"},[_c('Logo',{staticClass:"logo"}),_c('Menu',{staticClass:"menu"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }